import React from 'react';
import "./BarftLinkDialog.css"
import classNames from "classnames"
class BarftLinkDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            linkText: '',
            titleText: '',
            eidtModelOpenLink: true,
            linkError:false,
            titleError:false
        };
    }
    componentDidMount() {
        if (window.getSelection().rangeCount > 0) {
            const ele = window.getSelection().getRangeAt(0).startContainer.parentElement
            console.log(window.$(ele).parents('.bf-link'))
            this.setState({
                linkText: window.$(ele).parents('.bf-link').attr('href') || "",
                titleText:window.$(ele).parents('.bf-link').length>0? window.getSelection().anchorNode.data : ""
            })
        }
        console.log(window.getSelection())
    }
    linkTitleEdit = (event) => {
        this.setState({
            titleText: event.target.value
        })
    }
    linkAreaEdit = (event) => {
        this.setState({
            linkText: event.target.value
        })
    }
    clearFn = () => {
        window.$('.bsy-x-window-mask').remove()
    }
    onBlurLinkTextFn = ()=>{
        if(this.state.linkText!==""){
            this.setState({
                linkError:false
            })
        }
    }
    onBlurTitleFn = ()=>{
        if(this.state.titleText!==""){
            this.setState({
                titleError:false
            })
        }
    }
    saveFn = () => {
        if (this.state.linkText === "") {
            this.setState({
                linkError:true
            })
        }
        if(this.state.titleText === ""){
            this.setState({
                titleError:true
            })
        }
        if(this.state.titleText!=="" && this.state.linkText !== ""){
            this.props.emitRichLinkConfig()
            this.clearFn()
        }
    }
    render() {
        return <div className='barft-link-dialog-page'>
            <div className='section'>
                <div>
                    <div className='title'><div className='error-icon'>*</div><div>链接地址</div></div>
                    <div className='right-input'>
                        <input placeholder="https://"
                            defaultValue={this.state.linkText}
                            className={classNames(this.state.linkError?'active':'')}
                            onInput={(event) => {
                                this.linkAreaEdit(event);
                            }}
                            onBlur={this.onBlurLinkTextFn}
                        ></input>
                        {this.state.linkError&&  <div className='error-text'>此项为必填项</div>}
                       
                    </div>
                </div>
                {/* <div className='input-notice'>
                    链接可用文本跳转地址
                </div> */}
                <div className='link-title-box'>
                    <div className='title'><div className='error-icon'>*</div><div>显示文本</div></div>
                    <div className='right-input'>
                        <input placeholder="请输入" className={classNames(this.state.titleError?'active':'')}
                            defaultValue={this.state.titleText}
                            onInput={(event) => {
                                this.linkTitleEdit(event);
                            }}
                            onBlur={this.onBlurTitleFn}
                        ></input>
                       {this.state.titleError &&  <div className='error-text'>此项为必填项</div>}
                    </div>
                </div>
            </div>
            <div className='footer'>
                <div className="op-name" onClick={() => {
                    let isState = this.state.eidtModelOpenLink
                    this.setState({
                        eidtModelOpenLink: !isState
                    })
                }}>
                    <i className={classNames(this.state.eidtModelOpenLink ? 'icon-bsy-select' : 'icon-bsy-check2')}></i>
                    <span>{React.language("data.submitPrompt.href.tip1")}</span>
                </div>
                <div>
                    <button className='BsyIconBtn white' onClick={this.clearFn}><span>取消</span></button>
                    <button className='BsyIconBtn blue' onClick={this.saveFn}><span>确定</span></button>
                </div>
            </div>
        </div>;
    }
}

export default BarftLinkDialog;